import Modal from './Modal.vue'


export default {
    install(Vue) {
        if (typeof window !== 'undefined' && window.Vue) {
            Vue = window.Vue
        }
        const VueComponent = Vue.extend(Modal);
        const vm = new VueComponent().$mount();
        let init = false;
        let defaultOptions = {
        yesBtnText: '确定',
        noBtnText: '取消'
        };

        const confirm = function (options) {
        Object.assign(vm,defaultOptions , options,{
            type:'confirm'
        });

        if (!init) {
            document.body.appendChild(vm.$el);
            init = true;
        }

        return vm.confirm();
        };


        Vue.prototype.$confirm = confirm
    }
}